// extracted by mini-css-extract-plugin
module.exports = {"root":"CookieBanner_root__mkMTf"};